import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getFreeResponseQuestions,
  getMultipleChoiceQuestions,
} from "../services/adminQuestionServices";
import { setQuestionStatus } from "../features/adminQuestionSlice";
import { DataStatus } from "../types/LearnTypes";
import { QuestionType } from "../types/adminQuestionTypes";

const dispatchFailure = (
  dispatch: any,
  status: DataStatus,
  type: QuestionType
) => {
  dispatch(
    setQuestionStatus({
      status,
      type,
    })
  );
};

export const retrieveAdminMCQAction = createAsyncThunk(
  "adminQuestion/getMCQ",
  async (
    {
      pageNumber,
      resultsPerPage,
    }: { pageNumber: number; resultsPerPage: number },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setQuestionStatus({
          status: DataStatus.loading,
          type: QuestionType.MCQ,
        })
      );
      const response = await getMultipleChoiceQuestions(pageNumber);
      if (response.data && response.status === 200) {
        thunkAPI.dispatch(
          setQuestionStatus({
            status: DataStatus.success,
            type: QuestionType.MCQ,
          })
        );
        return thunkAPI.fulfillWithValue(response.data);
      }
      dispatchFailure(thunkAPI.dispatch, DataStatus.failed, QuestionType.MCQ);
      return thunkAPI.rejectWithValue({
        message: "failed to get admin mcq questions",
      });
    } catch (error: any) {
      console.error("[!] Failed to fetch admin mcq questions", error);
      dispatchFailure(thunkAPI.dispatch, DataStatus.failed, QuestionType.MCQ);
      return thunkAPI.rejectWithValue({
        message: "Failed to get admin mcq",
      });
    }
  }
);

export const retrieveAdminFRQAction = createAsyncThunk(
  "adminQuestion/FRQ",
  async (
    {
      pageNumber,
      resultsPerPage,
    }: { pageNumber: number; resultsPerPage: number },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setQuestionStatus({
          status: DataStatus.loading,
          type: QuestionType.FRQ,
        })
      );
      const response = await getFreeResponseQuestions(pageNumber);
      if (response.data && response.status === 200) {
        thunkAPI.dispatch(
          setQuestionStatus({
            status: DataStatus.success,
            type: QuestionType.FRQ,
          })
        );
        return thunkAPI.fulfillWithValue(response.data);
      }
      dispatchFailure(thunkAPI.dispatch, DataStatus.failed, QuestionType.FRQ);
      return thunkAPI.rejectWithValue({
        message: "failed to get admin FRQ questions",
      });
    } catch (error: any) {
      console.error("[!] Failed to fetch admin FRQ questions", error);
      dispatchFailure(thunkAPI.dispatch, DataStatus.failed, QuestionType.FRQ);
      return thunkAPI.rejectWithValue({
        message: "Failed to get admin FRQ",
      });
    }
  }
);
